import script from "./BaseAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseAlert.vue?vue&type=script&setup=true&lang=js"

import "./BaseAlert.vue?vue&type=style&index=0&id=98b665d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98b665d4"]])

export default __exports__